// Validates prompt drafts before submission; mirrors the server's ValidatePrompts for early feedback.
const MAX_PROMPT_LENGTH = 500
export const MAX_EDITS_PER_SAVE = 10 // matches MaxEditsPerRequest in the Go runsvc

// Mirrors the Go promptKey in prompt_edit.go for ordinary text; the server's 422 is
// authoritative.
const promptKey = (s: string) =>
  s
    .trim()
    .split(/\s+/)
    .join(' ')
    .toLowerCase()
    .replace(/[.?!,;:… ]+$/u, '')

// Checks the drafts as a whole, so a swap passes; the server's 422 is authoritative.
export function validatePrompts(
  drafts: string[],
  prompts: string[]
): Map<number, string> {
  const errors = new Map<number, string>()
  const keys = drafts.map(promptKey)
  const changed = drafts.map((d, i) => d.trim() !== prompts[i].trim())

  drafts.forEach((draft, i) => {
    if (!changed[i]) return

    const trimmed = draft.trim()

    // A collision marks the changed row; of two changed rows, the later one.
    const collides = keys.some(
      (k, j) => j !== i && k === keys[i] && (!changed[j] || j < i)
    )

    if (!trimmed) errors.set(i, 'Enter a prompt.')
    else if ([...trimmed].length > MAX_PROMPT_LENGTH)
      errors.set(i, 'Keep the prompt to 500 characters or fewer.')
    else if (collides)
      errors.set(i, 'This tracker already measures this prompt.')
  })

  return errors
}
